import { ref, watch, onBeforeUnmount } from "@vue/composition-api";
import formValidation from "@core/comp-functions/forms/form-validation";
import { useToast } from "vue-toastification/composition";
import { useUtils as useI18nUtils } from "@core/libs/i18n";

export default function useWizardStep(props, { emit }, configDefaults = {}) {
  const { refFormObserver, getValidationState } = formValidation();
  const itemData = ref(JSON.parse(JSON.stringify(props.propItemData)));
  const { t } = useI18nUtils();
  const toast = useToast();

  const isUpdatingFromParent = ref(false);

  const initializeConfig = () => {
    if (!itemData.value.config) {
      itemData.value.config = {};
    }

    Object.entries(configDefaults).forEach(([key, value]) => {
      if (itemData.value.config[key] === undefined) {
        itemData.value.config[key] = value;
      }
    });
  };

  initializeConfig();

  watch(
    () => props.propItemData,
    (newValue) => {
      if (newValue && Object.keys(newValue).length > 0) {
        isUpdatingFromParent.value = true;

        const currentConfig = itemData.value.config || {};
        itemData.value = JSON.parse(JSON.stringify(newValue));

        if (!itemData.value.config || Object.keys(itemData.value.config).length === 0) {
          itemData.value.config = currentConfig;
        }

        initializeConfig();

        setTimeout(() => {
          isUpdatingFromParent.value = false;
        }, 0);
      }
    },
    { deep: true }
  );

  watch(
    () => itemData.value,
    (newValue) => {
      if (!isUpdatingFromParent.value) {
        emit("update:itemData", newValue);
      }
    },
    { deep: true }
  );

  const validateStep = async () => {
    if (!refFormObserver.value) {
      console.warn("Validation observer is not initialized");
      return false;
    }
    return await refFormObserver.value.validate();
  };

  return {
    refFormObserver,
    getValidationState,
    itemData,
    t,
    toast,
    validateStep,
    initializeConfig
  };
}
